import { X, Minus, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LangContext";
import { useDict } from "@/i18n/dict";
import { CART } from "@/constants/testIds";

export default function CartDrawer() {
  const { items, remove, setQty, subtotal, open, setOpen } = useCart();
  const { lang } = useLang();
  const t = useDict(lang);
  const navigate = useNavigate();

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60]" onClick={() => setOpen(false)}>
      <div className="absolute inset-0 bg-black/40" />
      <aside
        className="absolute right-0 top-0 bottom-0 w-full sm:w-[440px] bg-[var(--bg)] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-[color:rgba(0,16,48,0.1)]">
          <h2 className="font-serif-display text-3xl">{t.cart.title}</h2>
          <button onClick={() => setOpen(false)} aria-label="close" className="hover:opacity-60"><X size={18} /></button>
        </div>
        <div className="flex-1 overflow-y-auto no-scrollbar px-6 py-4">
          {items.length === 0 ? (
            <p data-testid={CART.empty} className="text-sm text-[color:var(--ink-2)] mt-8 text-center">{t.cart.empty}</p>
          ) : items.map((item) => (
            <div key={item.product_id} className="flex gap-4 py-4 border-b border-[color:rgba(0,16,48,0.08)]">
              <img src={item.image} className="w-20 h-24 object-cover bg-[var(--bg-2)]" alt="" />
              <div className="flex-1">
                <p className="font-serif-display text-xl leading-tight">{item.name[lang] || item.name.fr}</p>
                <p className="text-xs text-[color:var(--ink-2)] mt-1">{item.price.toFixed(2)} €</p>
                <div className="mt-3 flex items-center gap-3">
                  <button onClick={() => setQty(item.product_id, item.qty - 1)} className="border border-[color:rgba(0,16,48,0.2)] p-1"><Minus size={12} /></button>
                  <span data-testid={CART.itemQty(item.product_id)} className="text-sm w-6 text-center">{item.qty}</span>
                  <button onClick={() => setQty(item.product_id, item.qty + 1)} className="border border-[color:rgba(0,16,48,0.2)] p-1"><Plus size={12} /></button>
                  <button data-testid={CART.removeItem(item.product_id)} onClick={() => remove(item.product_id)} className="ml-auto text-xs underline text-[color:var(--ink-2)] hover:text-[color:var(--red)]">{t.cart.remove}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-[color:rgba(0,16,48,0.1)] px-6 py-5">
            <div className="flex justify-between items-baseline mb-4">
              <span className="eyebrow">{t.cart.subtotal}</span>
              <span data-testid={CART.total} className="font-serif-display text-3xl">{subtotal.toFixed(2)} €</span>
            </div>
            <button
              data-testid={CART.checkoutBtn}
              onClick={() => { setOpen(false); navigate("/checkout"); }}
              className="btn-navy w-full justify-center"
            >
              {t.cart.checkout}
            </button>
          </div>
        )}
      </aside>
    </div>
  );
}
